module.exports = __webpack_public_path__ + "img/1567645082.687df313.jpg";